/* =========================================================
   FILTER DRAWER TOGGLE — FACETS SAFE (DELEGATED)
   ========================================================= */

document.addEventListener('click', (e) => {
  const openFilters = document.querySelectorAll(
    '.custom-filters-wrapper.open'
  );

  openFilters.forEach(container => {
    const button = document.querySelector(
      `[aria-controls="${container.id}"]`
    );

    const clickedInsideFilter = e.target.closest(
      '.custom-filters-wrapper'
    );

    const clickedToggleButton =
      button && button.contains(e.target);

    if (clickedInsideFilter || clickedToggleButton) {
      return;
    }

    container.classList.remove('open');
    container.setAttribute('inert', '');

    if (button) {
      button.setAttribute('aria-expanded', 'false');
    }
  });
});

document.addEventListener('click', function (e)  {
  const button = e.target.closest('[data-toggle-filters]');
  if (!button) return;

  e.stopPropagation();

  const targetId = button.getAttribute('aria-controls');
  const container = document.getElementById(targetId);

  if (!container) return;

  const isOpen = container.classList.contains('open');

  if (isOpen) {
    container.classList.remove('open');
    container.setAttribute('inert', '');
    button.setAttribute('aria-expanded', 'false');
  } else {
    container.classList.add('open');
    container.removeAttribute('inert');
    button.setAttribute('aria-expanded', 'true');
  }
});

// document.addEventListener('click', function (e) {
//   const facetLink = e.target.closest('.active-facets a');
//   if (!facetLink) return;

//   e.preventDefault();

//   applyFiltersFromURL(facetLink.href);
// });

/* =========================================================
  AJAX FILTERS
  ========================================================= */
const filterForm = document.querySelector('.facets__form');

if (filterForm) {
  filterForm.addEventListener('submit', async (e) => {
    e.preventDefault(); // prevent page reload
    await applyFiltersAJAX(filterForm);
  });
}

/* -----------------------------
Serialize filters
----------------------------- */

function serializeFilters(form) {
  const formData = new FormData(form);
  return new URLSearchParams(formData).toString();
}

/* -----------------------------
Show active filters
----------------------------- */

function showActiveFilters(form) {
  const el = document.getElementById('active-filters');
  if (!el) return;

  const selected = [];

  form.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
    selected.push(input.value);
  });

  renderPlansLayout();

  if (selected.length === 0) {
    el.innerHTML = '';
    return;
  }
}

/* -----------------------------
Apply filters with AJAX
----------------------------- */

async function applyFiltersAJAX(form) {  
  const provinceValue = localStorage.getItem("ProvinceValue");
  if (!provinceValue) return;

  const params = new URLSearchParams(window.location.search);
  const params2 = new URLSearchParams(serializeFilters(form));
  const countParams = [...params].length;
  const queryurl = `${window.location.pathname}?${serializeFilters(form)}`;
  let separator = '';
  if(countParams > 0) {
     separator = queryurl.includes('?') ? '&' : '?';
  }
  const url = `${queryurl}${separator}prov=${provinceValue}`;

  // ensure only one prov param
  params2.set("prov", provinceValue);
  const newUrl = `${window.location.pathname}?${params2.toString()}`;

  const oldProductsContainer = document.querySelector('reveal-items');
  if (!oldProductsContainer) return;

  /* Loading UI */

  oldProductsContainer.innerHTML = `
    <div class="filter-loading">
      <div class="spinner"></div>
      <p>Updating rate plans...</p>
      </div>
  `;

  try {
    const res = await fetch(url, {
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });

    const html = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    const newProductsContainer = doc.querySelector('reveal-items');
    
    if (newProductsContainer) {

      const products = newProductsContainer.querySelectorAll('product-card');

      if (products.length > 0) {
        oldProductsContainer.innerHTML = `
          <div id="active-filters"></div>
        ` + newProductsContainer.innerHTML;
      } else {
        oldProductsContainer.innerHTML = `
          <div id="active-filters"></div>
          <div class="no-results">
            <div class="no-results-icon">🔍</div>
            <h2>No rate plans match your selected filters.</h2>
            <p>Try adjusting or clearing the filter.</p>
            <a href="/collections/plans" class="bold reset-filters">
              Clear filters
            </button>
          </div>
        `;
      }

      /* Fade animation */

      oldProductsContainer.style.opacity = 0;

      requestAnimationFrame(() => {
        oldProductsContainer.style.transition = "opacity 0.3s";
        oldProductsContainer.style.opacity = 1;
      });

      /* Show active filters */

      showActiveFilters(form);

    } else {

      oldProductsContainer.innerHTML = `
        <div id="active-filters"></div>
        <div class="no-results">
          <div class="no-results-icon">🔍</div>
          <h2>No rate plans match your selected filters.</h2>
          <p>Try adjusting or clearing the filter.</p>
          <a href="/collections/plans" class="bold reset-filters">
            Clear filters
          </button>
        </div>
      `;
    }

    /* Update URL */
    window.history.replaceState({}, '', newUrl);
    
    /* Update counter if function exists */
    if (window.updateCounter) {
      window.updateCounter();
    }

  } catch (err) {
    console.error('Error fetching filtered products:', err);
  }
}


/* -----------------------------
Handle browser back/forward
----------------------------- */

window.addEventListener('popstate', () => {
  if (filterForm) {
    applyFiltersAJAX(filterForm);
  }
});

/* =========================================================
   COUNTER
   ========================================================= */

(function () {
  const shopifyCounter = document.querySelector('.general-product-count');
  if (shopifyCounter) shopifyCounter.style.display = 'none';

  function getLang() {
    return document.documentElement.lang.startsWith('fr') ? 'fr' : 'en';
  }

  window.updateCounter = function updateCounter() {

    const countVisible = [...document.querySelectorAll('.product-item')].filter(el => el.offsetParent !== null).length;
    const count = countVisible;
    
    if (count == 0){
      const oldProductsContainer = document.querySelector('reveal-items');
      if (!oldProductsContainer) return;

      oldProductsContainer.innerHTML = `
          <div id="active-filters"></div>
          <div class="no-results">
            <div class="no-results-icon">🔍</div>
            <h2>No rate plans match your selected filters.</h2>
            <p>Try adjusting or clearing the filter.</p>
            <a href="/collections/plans" class="bold reset-filters">
              Clear filters
            </button>
          </div>
        `;

    }

    const els = document.querySelectorAll('.filter-product-count');
    if (!els.length) return;
    
    const labels = {
      en: ['Rate plan', 'Rate plans'],
      fr: ['Forfait', 'Forfaits']
    };
    
    const [singular, plural] = labels[getLang()];
    const label = count === 1 ? singular : plural;
    
    els.forEach(el => {
      el.textContent = `${count} ${label}`;
      el.style.display = count ? '' : 'none';
    });
  };

  document.addEventListener('DOMContentLoaded', updateCounter);
  // Run whenever Shopify reloads sections (filters, sorting, etc.)
  document.addEventListener('shopify:section:load', () => {
    requestAnimationFrame(updateCounter);
  });

  // Track when Shopify fetches data and then the url and the counter are updated
  const originalFetch = window.fetch;

  window.fetch = async function (...args) {
    const url = args[0];

    const provinceValue = localStorage.getItem("ProvinceValue");

    if (provinceValue && typeof args[0] === "string" && args[0].includes("section_id=")) {
      const parsedUrl = new URL(args[0], window.location.origin);
      parsedUrl.searchParams.set("prov", provinceValue);
      args[0] = parsedUrl.toString();
    }

    const response = await originalFetch.apply(this, args);

    return response;
  };

  function updateNewUrl() {

    const provinceValue = localStorage.getItem("ProvinceValue");
    if (!provinceValue) return;
    const form = document.querySelector('#facet-form');

    const params = new URLSearchParams(serializeFilters(form));

    if (!params.get('page')) {
      params.delete('page');
    }
    // ensure only one prov param
    params.set("prov", provinceValue);

    const newUrl = `${window.location.pathname}?${params.toString()}`;

    window.history.replaceState({}, '', newUrl);
  }

  /* =========================================================
    Observe when url change due to filtering 
    and reender the layout and add prov param to the url
  ========================================================= */

  function onUrlChange(callback) {
    let lastUrl = location.href;

    const observer = new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        callback();
      }
    });

    observer.observe(document, { subtree: true, childList: true });

    // also catch back/forward
    window.addEventListener('popstate', callback);
  }

  onUrlChange(() => {
    updateNewUrl();
    renderPlansLayout();
  });

  /* =========================================================
    AJAX CLEAR FILTERS
    ========================================================= */

  // Clear Filters — AJAX
  const clearButton = document.querySelector('.filters-clear');

  if (clearButton && filterForm) {
    clearButton.addEventListener('click', async (e) => {
      e.preventDefault(); // prevent page reload

      // Uncheck all checkboxes AND enable them
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(input => {
        input.checked = false;
        input.disabled = false; // enable all filters
      });

      // Apply filters (fetch all products)
      await applyFiltersAJAX(filterForm);
      
      // Refresh layout
      renderPlansLayout();
    });
  }  

  // Rendering plans layout
  renderPlansLayout();
})();

/* =========================================================
       CHECK THE PROV PARAM
   ========================================================= */
function checkProvParam(){
  const params = new URLSearchParams(window.location.search);
  const provValues = params.getAll('prov');
  
  if (provValues.length > 1) {
    params.delete('prov');                 // remove all prov
    params.set('prov', provValues[0]);     // keep the first one
  
    const newUrl = `${window.location.pathname}?${params}`;
    window.history.replaceState({}, '', newUrl);
  }
}

// run when page loads
checkProvParam();

/* =========================================================
  Rendering rate plans based on the province tag
  ========================================================= */
function renderPlansLayout(){
  const paramsUrl = new URLSearchParams(window.location.search);
  let provinceSelected = paramsUrl.get('prov');

  // fallback to localStorage
  if (!provinceSelected) {
    provinceSelected = localStorage.getItem('ProvinceValue');
  }

  if (provinceSelected) {
    provinceSelected = provinceSelected.toLowerCase();

    document.querySelectorAll('.product-item').forEach(el => {
      const tags = el.dataset.tags;

      if (!tags.includes(`province_${provinceSelected}`)) {
        el.style.display = 'none';
      }
    });

    getPlanMetafields();
    window.updateCounter();

  }
}

/* =========================================================
   TRANSLATE DEVICES FACET LABELS
   ========================================================= */

// Translate the rate plan type and data to En or Fr
function translatePlanFacets() {

  const map = window.plansTranslationMap; // From the shop metafield custom.rate_plans_translation_map
  if (!map) return;

  const facets = document.querySelectorAll(
    '.active-facets .removable-facet'
  );
  const summary = document.querySelector('.active-facets');


  if (summary) {
    summary.classList.toggle('has-active-facets', facets.length > 0);
  }

  facets.forEach(facet => {
    const textNode = facet.childNodes[0];
    if (!textNode || textNode.nodeType !== Node.TEXT_NODE) return;
    
    const rawValue = textNode.textContent.trim();
    
    if (map[rawValue]) {
      textNode.textContent = map[rawValue];
    }
  });
}

/* =========================================================
   SAFE FACET SUMMARY OBSERVER
   ========================================================= */

let facetObserver = null;

function attachFacetObserver() {
  const summary = document.querySelector('.facets-summary');
  if (!summary) return;

  if (facetObserver) {
    facetObserver.disconnect();
  }

  facetObserver = new MutationObserver(() => {
    translatePlanFacets();
  });

  facetObserver.observe(summary, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });

  // Initial cleanup
  translatePlanFacets();
}

// Watch for Shopify section re-renders
const sectionObserver = new MutationObserver(() => {
  attachFacetObserver();
});

document.addEventListener('DOMContentLoaded', () => {
  sectionObserver.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });

  attachFacetObserver();
});

/* =========================================================
    FECTHING RATE PLAN METAFIELDS
   ========================================================= */

function getPlanMetafields() {
  const province = new URLSearchParams(window.location.search).get('prov');

  document.querySelectorAll('.plan-metafields').forEach(el => {
    const plan = getPlan(el, province);
    const shopifyLang = document.documentElement.lang.toLowerCase().startsWith('fr') ? 'fr' : 'en';

    if (!plan) return;

    const container = el.closest('.product-item');
    if (!container) return;

    const priceEl = container.querySelector('.plan_dynamic_price');
    const dataEl = container.querySelector('.plan_data');
    const airtimeEl = container.querySelector('.plan_airtime_msg');

    if (priceEl) priceEl.innerHTML = plan.price;
    if (dataEl) dataEl.innerHTML = formatDataMB(plan.plp_data, shopifyLang);
    if (airtimeEl) airtimeEl.innerHTML = plan.plp_air_time_messaging;
  });
}

function getPlan(el, province) {
  if (!el._plans) {
    el._plans = JSON.parse(el.dataset.planMetafields);
  }
  return el._plans[province];
}

function formatDataMB(value, lang = 'en') {
  const dataMb = Number(value);

  if (value === "Unlimited") {
    return lang?.toLowerCase().startsWith('fr') ? "Haute vitesse illimitées" : "Unlimited High-Speed";
  }

  if (isNaN(dataMb)) return '';

  if (dataMb >= 1000) {
    const gb = dataMb / 1000;
    return `${gb}${lang?.toLowerCase().startsWith('fr') ? ' Go' : ' GB'}`;
  } else {
    return `${dataMb}${lang?.toLowerCase().startsWith('fr') ? ' Mo' : ' MB'}`;
  }
}

getPlanMetafields();